export const CONTENT_TYPE_ASSET = 'asset';
export const CONTENT_TYPE_TEXT = 'text';
export const CONTENT_TYPE_LINK = 'link';
export const CONTENT_TYPE_IFRAME_EMBED = 'iframe_embed';
export const CONTENT_TYPE_PAGE_CONFIG = 'sections_style_configs';
// "section_background_image" is a slight misnomer since this can refer to
// background videos as well. As a backwards compatability concession we keep
// this content_type string for those videos.
export const CONTENT_TYPE_SECTION_BACKGROUND = 'section_background_image';
export const CONTENT_TYPE_API_FEED = 'api_feed';
export const CONTENT_TYPE_ACCORDION_ITEM = 'accordion_item';
export const CONTENT_TYPE_TAB_ITEM = 'tab_item';
export const CONTENT_TYPE_OVERLAY = 'overlay';
export const CONTENT_TYPE_DOWNLOADABLE = 'downloadable';